import React from "react";
import { Logo, Ornament } from "@/components/Logo";
import { HERO } from "@/constants/testIds";
import { trackCtaClick } from "@/lib/analytics";

export default function Hero({ onReserve }) {
  return (
    <section
      data-testid={HERO.root}
      className="relative overflow-hidden paper-texture"
    >
      {/* Subtle warm wash */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 20% 10%, rgba(212,175,55,0.10), transparent 55%), radial-gradient(ellipse at 90% 90%, rgba(114,47,55,0.06), transparent 60%)",
        }}
      />

      <div className="relative max-w-[1400px] mx-auto px-6 sm:px-10 pt-16 pb-24 md:pt-24 md:pb-32 grid md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-7 reveal-up">
          <div className="text-[11px] tracking-[0.5em] uppercase text-[#722F37]">
            An evening of original works
          </div>

          <h1
            data-testid={HERO.heading}
            className="font-serif mt-6 text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight font-light text-[#1A1A1A]"
          >
            The <em className="italic text-[#722F37]">king of pop art</em>.
            <br />
            Every piece, an original.
          </h1>

          <p className="mt-8 max-w-xl text-base text-[#1A1A1A]/70 leading-relaxed">
            Original works by <strong>Tom Pergola</strong> — mixed-media
            assemblage plastique sculpture, large pieces, and acrylic
            paintings — presented under the House of Master Brushes Fine Art.
            Each piece arrives with a signed Certificate of Authenticity and a
            Letter of Appreciation. Reservations are placed privately; payment
            is escrowed via Escrow.com.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="#gallery"
              data-testid={HERO.viewGalleryBtn}
              onClick={() => trackCtaClick("hero_view_gallery")}
              className="btn-gold px-8 h-12 inline-flex items-center justify-center tracking-[0.25em] text-[11px] uppercase font-medium"
            >
              View the gallery
            </a>
            <button
              data-testid={HERO.reserveBtn}
              onClick={() => {
                trackCtaClick("hero_reserve");
                onReserve && onReserve();
              }}
              className="btn-outline-gold px-8 h-12 inline-flex items-center justify-center tracking-[0.25em] text-[11px] uppercase font-medium"
            >
              Inquire / Reserve
            </button>
          </div>

          <div className="mt-14 flex items-center gap-8 text-[10px] uppercase tracking-[0.35em] text-[#1A1A1A]/60">
            <span>Certificate of authenticity</span>
            <span className="w-8 h-px bg-[#D4AF37]/70" />
            <span>Escrow.com secured</span>
          </div>
        </div>

        <div className="md:col-span-5 flex flex-col items-center reveal-up" style={{ animationDelay: "180ms" }}>
          <div className="relative">
            {/* Ornate frame */}
            <div className="absolute inset-0 -m-6 border border-[#D4AF37] pointer-events-none" />
            <div className="absolute inset-0 -m-2 border border-[#D4AF37]/40 pointer-events-none" />
            <div className="p-10 sm:p-14 flex items-center justify-center">
              <Logo size={340} />
            </div>
          </div>
          <div className="mt-8 w-48">
            <Ornament color="#D4AF37" />
          </div>
        </div>
      </div>
    </section>
  );
}
